import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';
import { requestNotificationPermission } from '../firebase';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('nuzlio_token');
    const savedUser = localStorage.getItem('nuzlio_user');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      authAPI.getMe().then(res => {
        const freshUser = res.data.data;
        localStorage.setItem('nuzlio_user', JSON.stringify(freshUser));
        setUser(freshUser);
      }).catch(() => {});
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    const { user, token } = res.data.data;
    localStorage.setItem('nuzlio_token', token);
    localStorage.setItem('nuzlio_user', JSON.stringify(user));
    setUser(user);
    requestNotificationPermission().catch(() => {});
    return user;
  };

  const register = async (data) => {
    const res = await authAPI.register(data);
    // Returns requiresVerification: true, no token yet
    return res.data;
  };

  const verifyEmail = async (email, code) => {
    const res = await authAPI.verifyEmail({ email, code });
    const { user, token } = res.data.data;
    localStorage.setItem('nuzlio_token', token);
    localStorage.setItem('nuzlio_user', JSON.stringify(user));
    setUser(user);
    requestNotificationPermission().catch(() => {});
    return user;
  };

  const resendVerification = async (email) => {
    const res = await authAPI.resendVerification({ email });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('nuzlio_token');
    localStorage.removeItem('nuzlio_user');
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const res = await authAPI.getMe();
      const freshUser = res.data.data;
      localStorage.setItem('nuzlio_user', JSON.stringify(freshUser));
      setUser(freshUser);
    } catch (err) {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, verifyEmail, resendVerification, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
